// extracted by mini-css-extract-plugin
export default {"header":"DetectionsTable_header__-h-GE","tablePagination":"DetectionsTable_tablePagination__ZXtmB"};